/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CreateAlertTemplateRequest {
    getFixupPrototypeFunction() { return CreateAlertTemplateRequest.fixupPrototype; }

    static newInstance(model: Partial<CreateAlertTemplateRequest>): CreateAlertTemplateRequest {
        let obj = Object.assign(new CreateAlertTemplateRequest(), model);
        CreateAlertTemplateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CreateAlertTemplateRequest>): CreateAlertTemplateRequest {
        if (!model) return null;
        return CreateAlertTemplateRequest.newInstance(<CreateAlertTemplateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CreateAlertTemplateRequest) {
        if (!obj) return;

        models.CreateAlertTemplateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CreateAlertTemplateRequest): boolean {
        Object.setPrototypeOf(obj, CreateAlertTemplateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.constraints) {
            models.ConstraintsRequest.fixupPrototype(this.constraints);
        }
    }

    /**
     * Specify the cloud service
     */
    service: string;

    /**
     * Provide the create template name.
     */
    create_template_name: string;

    /**
     * Boolean value to set template as default not not
     */
    is_default: boolean;

    /**
     * Provide cloud_account_id when scope is selected as cloud_account scope
     */
    cloud_account_id: Array<string>;

    /**
     * Select regions when scope is selected as region for an AWS cloud
     */
    regions: Array<string>;

    /**
     * Select resource_groups when scope is selected as resource_group for an Azure cloud
     */
    resource_groups: Array<string>;

    /**
     * Select the check box, if wish to apply the configuration for existing resource also
     */
    apply_to_existing_resource: boolean;

    /**
     * scope for the template to be created
     */
    scope: string;

    /**
     * Provide the constraints, if the template need to be mapped with constraints
     */
    constraints: models.ConstraintsRequest;

}
